module.exports = __webpack_public_path__ + "img/vlcsnap-2024-01-09-21h18m30s535.0cd73626.png";